import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { ButtonTs } from '@lt/components';

import { i18n } from '@lt/localization';
import {
  getIsOrderPrebuildFetching,
  getIsOrderPrebuilt,
} from 'checkout/store/selectors/order';
import { getValidations } from 'checkout/store/domains/tourists-checkout-validation/slice';
import { submitTouristAction } from 'checkout/store/actions/tourists';
import { getTouristsCount } from 'checkout/store/selectors/package';
import {
  getHotelFacts,
  getActualizationShowModalCustomer,
} from 'checkout/store/selectors/actualization';
import { touristsSelector } from 'src/store/tourists/selectors';

import styled from 'styled-components';
import { mobileCustomerFormVisibleSelector } from 'src/routes/Checkout/store/domains/customer/selectors';
import { HAS_CUSTOMER_FORM } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/components/Customer/abFeatures';
import { isValidSelector } from 'src/store/touristsValidation/selectors';
import { IS_NEW_TOURIST_VALIDATION } from 'src/store/touristsValidation/abFeatures';
import { ValidationCommonErrors } from './components/Validation';
import NoOnlyMenValidationText from '../../routes/Checkout/components/Tourists/OnlyMenWarning';
import { isMatchingHotelRequirements, isTouristsValid } from './utils';

// TODO: feature customer_form - Убрать ветку с HAS_CUSTOMER_FORM
const getButtonText = (isLastTourist: boolean, showCustomerForm: boolean) => {
  if (showCustomerForm && HAS_CUSTOMER_FORM) {
    return isLastTourist
      ? i18n.t('checkout.touristForm.submitMobile_customer')
      : i18n.t('checkout.touristForm.submitMobile');
  }
  return i18n.t('checkout.touristForm.submitMobile', {
    context: isLastTourist ? 'last' : '',
  });
};

const SubmitTouristMobile = (
  props: PropsFromRedux & { index: number },
): JSX.Element | null => {
  const {
    index,
    touristsCount,
    submitTourist,
    hotelFacts = {},
    tourists = [],
    isPrebuildFetching,
    isPrebuilt,
    touristsPassportValidations,
    mobileCustomerFormVisible,
    showCustomerForm,
    isNewValidationTourist,
  } = props;
  const isLastTourist = index + 1 === touristsCount;
  const buttonText = getButtonText(isLastTourist, showCustomerForm);
  const isMachingRequirments = isMatchingHotelRequirements(
    tourists,
    hotelFacts,
  );

  const isValid = IS_NEW_TOURIST_VALIDATION
    ? isNewValidationTourist
    : isTouristsValid(tourists, touristsPassportValidations);

  const btnDisabled =
    isPrebuildFetching || !isPrebuilt || (isLastTourist && !isValid);

  // TODO: feature customer_form - Удалить проп mobileCustomerFormVisible
  if (mobileCustomerFormVisible) return null;

  return !isMachingRequirments && isLastTourist ? (
    <NoOnlyMenValidationText
      path={hotelFacts?.no_single_men.redirect_url}
      isMobile
    />
  ) : (
    <>
      <ValidationCommonErrors />

      <ButtonContainer>
        <SubmitButton
          variant="primary"
          size="large"
          onClick={() => submitTourist(index)}
          disabled={btnDisabled}
        >
          {buttonText}
        </SubmitButton>
      </ButtonContainer>
    </>
  );
};

const ButtonContainer = styled.div`
  margin-top: 15px;
  margin-bottom: 5px;
  display: flex;
  width: 100%;
  justify-content: center;
`;

const SubmitButton = styled(ButtonTs)`
  width: 100%;
  font-size: 15px;
  white-space: pre-line;
`;

const mapStateToProps = (state) => ({
  mobileCustomerFormVisible: mobileCustomerFormVisibleSelector(state),
  touristsCount: getTouristsCount(state),
  hotelFacts: getHotelFacts(state),
  tourists: touristsSelector(state),
  isPrebuildFetching: getIsOrderPrebuildFetching(state),
  isPrebuilt: getIsOrderPrebuilt(state),
  touristsPassportValidations: getValidations(state),
  showCustomerForm: getActualizationShowModalCustomer(state),
  isNewValidationTourist: isValidSelector(state),
});

const mapDispatchToProps = {
  submitTourist: submitTouristAction,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(SubmitTouristMobile);
